export const selectRouting = (state) => state.routing;

export const selectRoutingHistory = (state) => {
  const routing = selectRouting(state);
  return routing.history;
};
